import { useTheme } from "../hooks/useTheme";

const GraphiteLogo = ({ className = "h-8 w-auto" }) => {
  const { isDarkMode } = useTheme();

  return (
    <div
      className={`${className} flex items-center gap-3 cursor-pointer hover:opacity-80 transition-opacity duration-200`}
    >
      {/* Logo SVG */}
      <img
        src="/graphbyte.svg"
        alt="GraphByte Logo"
        className={`h-full w-auto object-contain transition-all duration-300 ${
          isDarkMode
            ? "brightness-0 invert filter drop-shadow-sm" // Makes the logo white in dark mode with subtle shadow
            : "brightness-100 drop-shadow-sm"
        }`}
        loading="eager"
        decoding="async"
      />

      {/* Company Name */}
      <span
        className={`text-xl sm:text-2xl font-bold tracking-tight transition-colors duration-300 ${
          isDarkMode ? "text-white drop-shadow-sm" : "text-graphite-darkest"
        }`}
        style={{ fontFamily: "Montserrat, sans-serif" }}
      >
        GraphByte
      </span>
    </div>
  );
};

export default GraphiteLogo;
